'use client';

export { BattleHistoryScreen } from './BattleHistoryScreen';
